export function getDeliveryDate(days: number): string {
  const date = new Date();
  date.setDate(date.getDate() + days);

  const day = date.getDate();
  const monthShort = date.toLocaleString("en-US", { month: "short" });
  const yearShort = String(date.getFullYear()).slice(-2);

  return `${day} ${monthShort} '${yearShort}`;
}
